import React from 'react';
import styled from 'styled-components';
import { useStoreState } from 'easy-peasy';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { isNaN } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import moment from 'moment-timezone';

import Layout from '../../../components/global/Layout';
import Header from './Header';
import { TextArea, CheckBox, Select } from '../../../components/elements';
import { fetchOrder, updateOrderWithRefund } from './helpers';
import Footer from './Footer';
import RefundStats from './RefundStats';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
`;

const LeftSpan = styled.span`
  display: flex;
`;

const RightSpan = styled.span`
  padding-left: 10px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 300px;
  display: inline-block;
  position: relative;
  top: 5px;
`;

const Form = ({
  order,
  userId,
  orderId,
  setFieldValue,
  values,
  history,
  handleSubmit,
  isSubmitting,
}) => {
  console.log('userId...', userId);
  console.log('orderId...', orderId);
  console.log('values...', values);

  React.useEffect(() => {
    console.log('setting timezone =', order?.place?.timezone);
    moment.tz.setDefault(order?.place?.timezone);
  }, [order?.place?.timezone]);

  return (
    <Layout>
      <Header
        history={history}
        loading={isSubmitting}
        handleSubmit={handleSubmit}
      />
      <Container>
        <div>
          <LeftSpan>Place Name</LeftSpan>
          <RightSpan>{order?.place?.name}</RightSpan>
        </div>
        <div />
        <div>
          <LeftSpan>Order ID</LeftSpan>
          <RightSpan>{order?.order_reference}</RightSpan>
        </div>
        <div>
          <LeftSpan>Order Total</LeftSpan>
          <RightSpan>
            ${parseFloat(order?.billing?.order_total).toFixed(2)}
          </RightSpan>
        </div>
        <div>
          <LeftSpan>Customer</LeftSpan>
          <RightSpan>
            {order?.created_by_user?.display_name}
            <span style={{ fontSize: '12px', fontWeight: '400' }}>
              &nbsp;({order?.created_by_user?.email})
            </span>
          </RightSpan>
        </div>
        <div>
          <LeftSpan>Order Amount</LeftSpan>
          <RightSpan>
            ${parseFloat(order?.billing?.order_amount).toFixed(2)}
          </RightSpan>
        </div>
        <div>
          <LeftSpan>Phone</LeftSpan>
          <RightSpan>
            {
              order?.created_by_user?.contact.find(ele => ele.type === 'mobile')
                ?.value
            }
          </RightSpan>
        </div>
        <div>
          <LeftSpan>Total Refund</LeftSpan>
          <RightSpan>${parseFloat(values.previousRefund).toFixed(2)}</RightSpan>
        </div>
        <div />
        <div>
          <LeftSpan>Previously Refunded</LeftSpan>
          <RightSpan>${parseFloat(values.lastRefund).toFixed(2)}</RightSpan>
        </div>
        <div className="m-2" />
        <div className="m-2" />
        <div style={{ display: 'flex' }}>
          <LeftSpan>
            Refund Amount <span className="help is-danger is-size-4">*</span>
          </LeftSpan>
          <div
            className="field"
            style={{ paddingLeft: '10px', position: 'relative', bottom: '5px' }}
          >
            <p className="control has-icons-left">
              <input
                className="input is-primary"
                type="number"
                placeholder="0.00"
                style={{ width: '100px' }}
                onChange={e => {
                  if (e.target.value === '') {
                    setFieldValue('value', null);
                  } else if (!isNaN(parseFloat(e.target.value))) {
                    setFieldValue('value', parseFloat(e.target.value));
                  }
                }}
              />
              <span className="icon is-small is-left">$</span>
            </p>
          </div>
        </div>
        <div />
        <div>
          <Select
            label="Reason"
            options={[
              {
                label: 'Duplicate',
                value: 'Duplicate',
              },
              {
                label: 'Fraudulent',
                value: 'Fraudulent',
              },
              {
                label: 'Requested by customer',
                value: 'Requested by customer',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ]}
            value={[values.type]}
            required
          />
        </div>
        <div>
          <CheckBox
            label="Refund From Restaurant"
            name="refund_from_restaraunt"
            value={values.reverse_transfer}
            onChange={() =>
              setFieldValue('reverse_transfer', !values.reverse_transfer)
            }
            disabled={
              values.hasAlreadyRefunded || values.refund_application_fee
            }
          />
          <CheckBox
            label="Refund Kravein Fee"
            name="refund_from_kravein_fee"
            value={values.refund_application_fee}
            onChange={() => {
              setFieldValue(
                'refund_application_fee',
                !values.refund_application_fee,
              );
              setFieldValue('reverse_transfer', !values.refund_application_fee);
            }}
            disabled={values.hasAlreadyRefunded}
          />
        </div>
        <div>
          <TextArea
            label="Note"
            name="Note"
            optionalText="(Min 10 and Max 8000 Characters)"
            placeholder="Add more details about this refund"
            value={values.note}
            onChange={e => setFieldValue('note', e.target.value)}
            required
          />
        </div>
        <div />
        <div style={{ display: 'flex' }}>
          <LeftSpan>
            Approval Code <span className="help is-danger is-size-4">*</span>
          </LeftSpan>

          <div style={{ paddingLeft: '15px' }}>
            <input
              className="input is-primary"
              type="text"
              placeholder="XXXXXXX"
              style={{ width: '100px' }}
              onChange={e => {
                setFieldValue('approvalCode', e.target.value);
              }}
            />
          </div>
        </div>
        <div />
        <div />
        <div />
        <div>
          <LeftSpan>Refunds</LeftSpan>
          <RefundStats stats={values.refundSummary} />
          <RightSpan />
        </div>
      </Container>
      <Footer
        history={history}
        isSubmitting={isSubmitting}
        handleSubmit={handleSubmit}
      />
    </Layout>
  );
};

const extractRefunds = order => {
  if (
    order?.payment?.refund &&
    Array.isArray(order?.payment?.refund) &&
    order?.payment?.refund.length !== 0
  ) {
    return order?.payment?.refund.reduce((prev, curr) => {
      let temp = prev;
      if (curr.refund_amount) {
        temp += parseFloat(curr.refund_amount);
      }
      return temp;
    }, 0);
  }
  return null;
};

const lastRefundAmount = order => extractRefunds(order) ?? 0;

// const lastRefundNote = order => extractRefunds(order)?.note?.type ?? null;

const transformRefundAmount = val => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : Math.abs(num);
};

const Refunds = withFormik({
  mapPropsToValues: ({ userId, orderId, order }) => {
    const refundsDetails =
      order?.payment?.refund && Array.isArray(order?.payment?.refund)
        ? order?.payment?.refund
        : [];

    const refundSummary = [];
    let totalRefund = 0;
    let lastRefund = 0;
    let refundApplicationFee = false;
    let reverseTransfer = true;

    refundsDetails.forEach(ele => {
      const ra = transformRefundAmount(ele.refund_amount);
      totalRefund += ra;
      lastRefund = ra;

      refundApplicationFee = ele.refund_application_fee;
      reverseTransfer = ele.reverse_transfer;

      const temp = {
        userId: ele.created_by,
        refundAmount: ra,
        refundType: ele.refund_type,
        refundedAt: ele.created_at,
        status: ele.status,
        refundReason: ele.refund_reason,
        note: ele.note,
      };

      refundSummary.push(temp);
    });

    const hasAlreadyRefunded = !(totalRefund === 0);

    return {
      user_id: userId,
      menu_order_id: orderId,
      action: 'refund',
      type: {
        label: 'Other',
        value: 'Other',
      },
      value: null,
      note: null,
      approvalCode: '',
      refund_application_fee:
        refundApplicationFee === true || refundApplicationFee === false
          ? refundApplicationFee
          : false,
      reverse_transfer:
        reverseTransfer === true || reverseTransfer === false
          ? reverseTransfer
          : true,
      previousRefund: lastRefundAmount(order),
      refundSummary,
      hasAlreadyRefunded,
      lastRefund,
    };
  },

  handleSubmit: async (values, { props }) => {
    // if (!(values.refund_application_fee || values.reverse_transfer)) {
    //   toast.error(
    //     `Atleast one option must be selected from 'Refund From Restaurant' and 'Refund Kravein Fee'!`,
    //   );
    //   return;
    // }

    const valueValidationSchema = yup.object({
      value: yup
        .number()
        .nullable()
        .required('Refund Amount is required!')
        .positive('Refund Amount must be positive!'),
    });
    const data1 = { value: values.value };

    try {
      valueValidationSchema.validateSync(data1, { abortEarly: false });
    } catch (error) {
      toast.error(error.errors[0]);
      return;
    }

    const noteValidationSchema = yup.object({
      note: yup
        .string()
        .nullable('Note is required!')
        .min(10, 'Please enter at least 10 characters')
        .max(8000, 'Please enter less than 8000 characters')
        .required('Note is required!'),
    });
    const data2 = { note: values.note };

    try {
      noteValidationSchema.validateSync(data2, { abortEarly: false });
    } catch (error) {
      toast.error(error.errors[0]);
      return;
    }

    const approvalCodeValidationSchema = yup.object({
      approval_code: yup.string().required('Please enter your approval code!'),
    });

    const data3 = { approval_code: values.approvalCode };

    try {
      approvalCodeValidationSchema.validateSync(data3, { abortEarly: false });
    } catch (error) {
      toast.error(error.errors[0]);
      return;
    }

    const {
      user_id,
      menu_order_id,
      action,
      type,
      value,
      note,
      refund_application_fee,
      reverse_transfer,
      approvalCode,
    } = values;

    const input = {
      user_role: 'kravein_super_admin',
      user_id,
      menu_order_id,
      action,
      approval_code: approvalCode,
      refund_application_fee,
      reverse_transfer,
      refunds: {
        type: type.value,
        value,
        note: { type: note },
      },
    };

    try {
      const res = await updateOrderWithRefund({ input });

      if (res) {
        toast.error(res);
      } else {
        swal('You have successfully refunded the order').then(() =>
          props.history.goBack(),
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  },
})(Form);

const Index = ({ history, match }) => {
  const { orderId } = match.params;
  const { userId } = useStoreState(state => state.auth);

  const [loading, setLoading] = React.useState(false);

  const [order, setOrder] = React.useState(null);

  React.useEffect(() => {
    const fetchFunc = async () => {
      setLoading(true);
      const o = await fetchOrder({ userId, menuOrderId: orderId });
      if (o) {
        setOrder(o);
      }
      setLoading(false);
    };
    fetchFunc();
  }, [orderId, userId]);

  if (!order) {
    return (
      <Layout>
        <Header />
        <span style={{ padding: '2rem', color: '#00AEEF' }}>Loading...</span>
      </Layout>
    );
  }

  return (
    <Refunds
      order={order}
      userId={userId}
      orderId={orderId}
      loading={loading}
      history={history}
    />
  );
};

export default Index;
